export default {"src":"/_next/static/media/DRAG_DROP_TRANSPARENT.b3b4ee2a.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};